/*eslint-disable*/
import React from "react";
import {
  Flex,
  Text,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdBolt } from "react-icons/md";

export default function Footer() {
  let textColor = useColorModeValue("gray.400", "white");
  return (
    <Flex
      zIndex='3'
      flexDirection={{
        base: "column",
        lg: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent='center'
      px={{ base: "30px", md: "0px" }}
      pb='30px'>
      <Flex direction='column' align='center'>
        <Text color={textColor} textAlign='center'>
          &copy; {1900 + new Date().getYear()} Afriq-NW. All Rights Reserved.
        </Text>
        <Flex align='center' justify='center' mt='4px'>
          <Icon as={MdBolt} color={textColor} w='16px' h='16px' me='6px' />
          <Text color={textColor} textAlign='center'>
            Powered by DeepXLabs
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
